import { useQuery } from 'react-query';
import hash from 'object-hash';
const baseRoute = process.env.REACT_APP_BASE_URL;
import { UserType } from '../types/types';

export interface GrupoType {
  _id?: string
  nombre: string,
  esEquipo?: boolean,
}

async function getGrupos(user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/grupos`,
    { headers,  method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as GrupoType[];
}

async function deleteGrupo(id?:string | null, user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  if (!id) return null;
  const response = await fetch(
    `${baseRoute}/api/grupos?id=${id}`,
    { headers, method: 'DELETE' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

async function addGrupo(params?: GrupoType | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (params === null) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/grupos`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as GrupoType;
}

export function useGetGrupos(user?: UserType | null) {
  return useQuery<GrupoType[] | null, Error>(
    ['getGrupos', hash(user ?? '')],
    () => getGrupos(user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useDeleteGrupos(id?:string | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['deleteGrupos', hash(user ?? '')],
    () => deleteGrupo(id, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}

export function useAddGrupos(params?: GrupoType | null, user?: UserType | null) {
  return useQuery<GrupoType | null, Error>(
    ['addGrupos', hash(params ?? ''), hash(user ?? '')],
    () => addGrupo(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}
